<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Loving Leadership</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#foreword-by-dr-kevin-treston">Foreword by Dr Kevin Treston</a></li><li id="toc-li-5"><a href="#/text/ch005#introduction">Introduction</a></li><li id="toc-li-6"><a href="#/text/ch006#chapter-1-there-is-no-enemy">Chapter 1 There Is No Enemy</a></li><li id="toc-li-7"><span href="#/text/ch007#chapter-2-grow-and-develop" title="Link target outside of Sample">Chapter 2 Grow and Develop</span></li><li id="toc-li-8"><span href="#/text/ch008#chapter-3-embrace-paradox" title="Link target outside of Sample">Chapter 3 Embrace Paradox</span></li><li id="toc-li-9"><span href="#/text/ch009#chapter-4-relationships-are-sacred" title="Link target outside of Sample">Chapter 4 Relationships Are Sacred</span></li><li id="toc-li-10"><span href="#/text/ch010#chapter-5-think-long-term" title="Link target outside of Sample">Chapter 5 Think Long Term</span></li><li id="toc-li-11"><span href="#/text/ch011#chapter-6-meaning-matters" title="Link target outside of Sample">Chapter 6 Meaning Matters</span></li><li id="toc-li-12"><span href="#/text/ch012#conclusion-to-love-is-to-lead" title="Link target outside of Sample">Conclusion – To Love Is to Lead</span></li><li id="toc-li-13"><span href="#/text/ch013#my-loving-leadership-plan" title="Link target outside of Sample">My Loving Leadership Plan</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?3352b08c